import { TransactionStatus } from 'store';
import { IMultisigTransaction } from 'utils/transform-multisig-transaction';

const isHitstoryTransaction = (status: TransactionStatus, transaction: IMultisigTransaction) =>
  status === TransactionStatus.EXECUTED ||
  status === TransactionStatus.REJECTED ||
  status === TransactionStatus.EXECUTION_ERRORED ||
  (status === TransactionStatus.SIGNED && transaction.type === 'SIGNATURE');

export const getHistoryTransactions = (transactions?: IMultisigTransaction[]) =>
  (transactions || [])
    .filter((item) => isHitstoryTransaction(item.status, item))
    .sort((a, b) => {
      return b.nonce - a.nonce;
    });

export const getQueueTransactions = (transactions?: IMultisigTransaction[]) =>
  (transactions || [])
    .filter((item) => !isHitstoryTransaction(item.status, item))
    .sort((a, b) => {
      return a.nonce - b.nonce;
    });
